import Vue from 'vue';
import { HasError, AlertError, AlertSuccess } from 'vform';
import VueAlertify from 'vue-alertify';

Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);
Vue.component(AlertSuccess.name, AlertSuccess);

Vue.use(VueAlertify, {
  notifier: {
    position: 'top-right',
    delay: 4,
  },
});

// Load global components dynamically
const requireContext = require.context('./global', false, /.*\.(js|vue)$/);
requireContext.keys().forEach(file => {
  const Component = requireContext(file).default;

  if (Component.name) {
    Vue.component(Component.name, Component);
  }
})
